import { Box, BoxProps, ColorOptions, convertHexToRGBA, ModalDialogNew, ModBox, Spacer, Text } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import NetInfo from '@react-native-community/netinfo'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Alert, FlatList } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { ToastPosition, ToastType } from '../../comps/Toast'
import { RootStore } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Colors, isOsMobile, logEvent, storeData } from '../../util/util'
import { BillPaymentModal } from '../BillPayments/BillPaymentModal'
import { VoiceBoxListModal } from '../ProfileMobile/ProfileComp/VoiceBoxListModal'

const quickLinkData = (
  isUserManagementEnabled: boolean,
  disableBillPayment: boolean,
  showChatbotAwareness: boolean,
) => {
  const manageUsers = {
    label: 'Manage Users',
    icon: 'ManageUsersIcon',
    comp: Routes.USER_MANAGEMENT.MANAGE_USERS,
  }

  const billPay = {
    label: 'Bill Payments',
    icon: 'BillPaymentRupeeIcon',
    comp: Routes.BILL_PAYMENTS,
  }

  const devices = {
    label: 'My Devices',
    icon: 'CalculatorIcon',
    comp: 'voiceBoxList',
  }
  const data: any = [
    {
      label: 'Help & Support',
      icon: 'SupportIcon',
      comp: Routes.SUPPORT,
      showChatbotAwareness: showChatbotAwareness,
    },
  ]

  if (isUserManagementEnabled) {
    data.splice(0, 0, manageUsers)
  }

  if (isOsMobile()) {
    data.splice(0, 0, devices)
    // if (!disableBillPayment) {
    //   data.splice(1, 0, billPay)
    // }
  }
  return data
}

const RenderProfileItems = ({ item, handleOnpress, index, width }: any) => {
  return (
    <Box
      align="center"
      key={index}
      width={width}
      justify="flex-start"
      testID={'quick-link-' + item.label?.replaceAll(' ', '')}
      onPress={() => handleOnpress(item)}
      underlayColor="TRANSPARENT">
      <Box align="center" width={62}>
        <Box
          align="center"
          justify="center"
          width={48}
          height={48}
          borderRadius={48}
          position="relative"
          backgroundColor={convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions}>
          <ModBox show={item?.showChatbotAwareness === true} {...getChatbotAwarenessStyle} />
          <SvgImage imageName={item.icon} color={Colors.SECONDARY} />
        </Box>
        <Spacer size={12} direction="vertical" />
        <Text
          numberOfLines={3}
          color={'BLACK'}
          fontSize={12}
          fontFamily="JioType-Medium"
          textAlign="center"
          lineHeight={16}
          letterSpacing={-0.06}>
          {item.label}
        </Text>
      </Box>
    </Box>
  )
}

export const QuickLinks = ({ isUserManagementEnabled, disableBillPayment, showChatbotAwarenessCount = 0 }: any) => {
  const [showModal, setShowModal] = useState(false)
  const [showBillPaymentModal, setShowBillPaymentModal] = useState(false)
  const getQuickLiniks = quickLinkData(isUserManagementEnabled, disableBillPayment, showChatbotAwarenessCount < 5)
  const navigation = useNavigation()
  const isFocussed = useIsFocused()

  const [isConnected, setIsConnected] = useState(null)

  useEffect(() => {
    const unsubscribe = NetInfo.addEventListener((state) => {
      setIsConnected(state.isConnected)
    })

    // Unsubscribe when the component unmounts
    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (isFocussed) {
      setShowModal(false)
      setShowBillPaymentModal(false)
    }
  }, [isFocussed])

  const onSubmitBillRequest = () => {
    setShowBillPaymentModal(false)
    RootStore?.response?.setCustomToast({
      message: 'Your bill payment request is submitted',
      color: defaultColors.GREEN,
      position: ToastPosition.BOTTOM,
      toastType: ToastType.POSITIVE,
    })
  }

  const handleOnpress = (item: any) => {
    logEvent('quickLink_pressed', item.label)
    if (item.comp === 'voiceBoxList') {
      if (isConnected) {
        setShowModal(true)
      } else {
        Alert.alert('Internet Connection', 'You are offline. Please Turn on mobile data or connect to a Wifi.')
      }
    } else if (item.comp === Routes.BILL_PAYMENTS) {
      if (isConnected) {
        setShowBillPaymentModal(true)
      } else {
        Alert.alert('Internet Connection', 'You are offline. Please Turn on mobile data or connect to a Wifi.')
      }
    } else {
      const params: any = {
        header: item?.label ?? '',
      }
      if (Routes.SUPPORT) {
        params.showChatbotAwareness = item.showChatbotAwareness
        if (showChatbotAwarenessCount < 5) {
          storeData('chatbotAwarenessShown', showChatbotAwarenessCount + 1)
        }
      }
      navigation.navigate(item.comp as never, params as never)
    }
  }
  return (
    <Box>
      <FlatList
        data={getQuickLiniks}
        numColumns={4}
        renderItem={({ item, index }: any) => (
          <RenderProfileItems
            key={`${item.icon}-${index}`}
            item={item}
            width={'25%'}
            index={`${item.icon}-${index}`}
            handleOnpress={handleOnpress}
          />
        )}
        keyExtractor={(item, index) => `links_${index}`}
        extraData={getQuickLiniks}
      />
      <Box>
        {isOsMobile() && (
          <ModalDialogNew
            animate={true}
            show={showModal}
            type="bottom"
            backgroundColor="TRANSPARENT"
            onBackPress={() => setShowModal(false)}>
            <VoiceBoxListModal onDismiss={(visible) => setShowModal(visible)} />
          </ModalDialogNew>
        )}
        {isOsMobile() && (
          <ModalDialogNew
            onBackPress={() => setShowBillPaymentModal(false)}
            show={showBillPaymentModal}
            type="bottom"
            backgroundColor="TRANSPARENT">
            <BillPaymentModal
              showBillPaymentModal={showBillPaymentModal}
              onProceed={onSubmitBillRequest}
              onDismiss={(visible: boolean) => setShowBillPaymentModal(visible)}
              type={'INIT'}
            />
          </ModalDialogNew>
        )}
      </Box>
    </Box>
  )
}

const getChatbotAwarenessStyle = {
  backgroundColor: Colors.GREEN_ERROR_BG,
  position: 'absolute',
  top: 0,
  right: 0,
  width: 10,
  height: 10,
  borderRadius: 10,
} as BoxProps
